import { parseSafeInt } from "Backend";
import { GetLensRuleStructureDocument } from "generated/graphql";
import { runGqlQuery } from "gqlClient";
import { LoaderFunction, LoaderFunctionArgs, redirect } from "react-router-dom";
import { useRouteLoaderData } from "react-router-typesafe";
import { addLoaderError } from "redux/slices/loader-error.slice";
import store from "redux/store";

export const lensSpecLoader = (async (args: LoaderFunctionArgs) => {
  const lensId = parseSafeInt(args.params.lensId);

  if (lensId === undefined) {
    return redirect("..");
  }
  const fetchLensRuleStructure = runGqlQuery(GetLensRuleStructureDocument, {
    lensId,
  })
    .then((r) => r.lens.ruleStructure.fields)
    .catch((e) => {
      store.dispatch(
        addLoaderError({
          loaderName: "lensSpecLoader",
          message: "Unable to load criteria",
        })
      );
      console.error(e);
      return [];
    });
  return fetchLensRuleStructure;
}) satisfies LoaderFunction;

export const useLensSpecsLoader = () => {
  return useRouteLoaderData<typeof lensSpecLoader>("lens/specification");
};
